export const ENVIRONMENT_GLOBAL = {
  envName: 'global',
  matomoSrc: '',
  loggingEnabled: true,
  pageSize: 30,
  searchSelectPageSize: 10,
  debounceTime: 750,
  debounceTimeSearchSelect: 200,
  inputErrorSnackbarDuration: 3000,
  dialogs: {
    large: {
      width: '80vw',
      maxWidth: '1104px',
      minWidth: '350px'
    }
  },
  appVersion: require('../../package.json').version,
  redirect: {
    route: '/oauth'
  },
  auth_L1: {
    endpoint: {
      paths: {
        account: '/account',
        login: '/protocol/openid-connect/auth',
        token: '/protocol/openid-connect/token',
        certs: '/protocol/openid-connect/certs',
        logout: '/protocol/openid-connect/logout',
        register: '/protocol/openid-connect/registrations'
      }
    }
  },
  backend: {
    endpoint: {
      paths: {
        prefix: '/api',
        token: '/auth/token',
        logout: '/auth/logout'
      }
    },
    wsEndpoint: '',
    wsHeartbeatIntervalMs: 20000
  },
  files: {
    paths: {
      prefix: '/docs',
      filePath: {}
    }
  },
  imprint: {
    endpoint: {
      paths: {
        imprint: '/impressum'
      }
    }
  },
  domains: {
    endpoint: {
      paths: {
        prefix: '/api/domains',
        profile: '/profile'
      }
    }
  },
  links: {
    help: 'https://www.meinhplus.de/wissenswertes/tutorials/fuer-feststellanlagen-und-andere-gewerke',
    applications: {
      mh2: {
        host: ''
      },
      l2: {
        host: '',
        domains: '/multi-domain-mgmt'
      },
      hcp: {
        host: ''
      },
      go: {
        host: ''
      },
      hpo: {
        host: ''
      },
      b2b: {
        host: ''
      },
      dongle: {
        host: '',
      },
      dongle_admin: {
        host: ''
      },
      learn_world: {
        host: ''
      },
      elec_calc_tool: 'https://www.hekatron-planungstools.de/stromberechnung.php',
      tender_tool_extend: 'https://www.hekatron-planungstools.de/Extend.php',
      remote_admin: 'https://remote.meinhplus.de/admin',
      remote_desktop: 'https://remote.meinhplus.de/iac20desktop/',
      status: 'https://h.meinhplus.de/hplus-status-ihr-brandschutz-plus-fuer-aufschaltung',
      ai_plan: 'https://plan.meinhplus.de'
    }
  },
  oms: {
    endpoint: {
      paths: {
        prefix: '/api/omskeys',
        lastdownload: '/lastdownload',
        validate: '/validate',
        history: '/history',
        export:"/exports",
        csv: '/csv',
        serialnumber: "/serialnumber",
        order: "/order"
      }
    }
  },
  users: {
    endpoint: {
      paths: {
        prefix: '/api/users',
        profile: '/profile',
        applications: '/applications'
      }
    }
  },
  domaindata: {
    endpoint: {
      paths: {
        prefix: '/api/domain',
        companydata: '/companydata'
      }
    }
  },
  captcha: {
    // Site key for DEV / TEST
    sitekey: 'FCMTS8TK2HG643S4',
  }
};
